module.exports = __webpack_public_path__ + "static/media/homepage-section-2.884a0f5d.png";